import { makeObservable } from 'mobx';

import { UserData, Optional, UserStatus } from 'chaika-frontend-types/frontend-cms';

import { User } from '@store/models/User';
import { List } from '@store/abstract/List';

export interface FilterParams {
    ids?: string[];
    email?: string;
    query?: string;
    organizationId?: string;
    organizationIds?: string[];
    mainOrganizationId?: string[];
    isDoctor?: boolean;
    roles?: string[];
    canBeEpisodeManager?: boolean;
    excludedIds?: string[];
    withoutTechnical?: boolean;
    status?: UserStatus;
    statuses?: UserStatus[];
}

export class UserList extends List<User, UserData, FilterParams> {
    public static Name = 'userList' as const;

    constructor(params?: UserData[]) {
        super(params);
        makeObservable(this);
    }

    public getByEmail(email: string): Optional<User> {
        return this.getFilteredValues({ email })[0];
    }

    protected create(params: UserData): User {
        return new User(params);
    }

    protected filterValue(
        user: User,
        {
            ids,
            status,
            statuses,
            organizationId,
            organizationIds,
            isDoctor,
            mainOrganizationId,
            canBeEpisodeManager,
            excludedIds,
            email,
            withoutTechnical,
            query,
            roles,
        }: FilterParams,
    ): boolean {
        return (
            (withoutTechnical ? !user.isTechnical : true) &&
            (organizationId ? user.mainOrganizationId === organizationId : true) &&
            (organizationIds ? organizationIds.some(id => user.mainOrganizationId === id) : true) &&
            (isDoctor ? user.isDoctor === isDoctor : true) &&
            (canBeEpisodeManager ? user.canBeEpisodeManager === canBeEpisodeManager : true) &&
            (ids ? ids.includes(user.id) : true) &&
            (excludedIds ? !excludedIds.includes(user.id) : true) &&
            (!!status ? status === user.status : true) &&
            (!!email ? email === user.email : true) &&
            (roles ? roles.every(role => user.roles.some(it => it.name === role)) : true) &&
            this.filterFieldValueByArray(user, mainOrganizationId, 'mainOrganizationId') &&
            this.filterFieldValueByArray(user, statuses, 'status') &&
            (this.filterFieldValueIncludesString(user, query, 'fullName') ||
                this.filterFieldValueIncludesString(user, query, 'email'))
        );
    }
}

export const userList = new UserList();
